import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import "./placementAgreement.css";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faChevronLeft, faChevronRight, faCircleExclamation, faDownload, faEye, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { apiService } from '../../../../services/apiService';
import TaskKnowledge from '../I94Validation/TaskKnowledge';
import { Modal, Tab, Tabs } from 'react-bootstrap';
import { Box } from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import CaseDetails from '../CaseDetails/CaseDetails';
import { toast } from 'react-toastify';
import OnboardingOnlyCaseDiscussTab from '../I94Validation/OnboardingOnlyCaseDiscussTab';
function PlacementAgreements() {
    const location = useLocation();
    const parts_location = location.pathname.split("/");
    const onboardslug = parts_location[2] || null;
    const userid = parts_location[3] || null;
    const taskData = parts_location[4] || null;
    const permissionstest = JSON.parse(localStorage.getItem('permissions'));
    const [expanded, setExpanded] = useState(true);
    const Role_user = localStorage.getItem('role');
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const handleClose = () => {
        setShow(false);
    };
    const [showIndex, setShowindex] = useState(0);
    // const [showedit, setShowedit] = useState(false);
    // const [editMode, setEditMode] = useState(false);
    const [loading, setLoading] = useState(true);
    const [inLoading, setInLoading] = useState(true);
    const [jobseekerName, setJobseekername] = useState("");
    const [jobseekerid, setJobseekerid] = useState("");
    const [caseids, setcaseid] = useState("");
    
    const [activeTab, setActiveTab] = useState("overview");
    const [activeTabCase, setActiveTabCase] = useState("task");
    const [showCase, setShowCase] = useState(false);
    const [CaseAlldetail, setCaseAllDetail] = useState([]);
    const [showCurrcase, setCaseIdscurrent] = useState('');
    useEffect(() => {
        if(taskData){
            const fetchData = async () => {
                try {
                    const response = await apiService.getRequest(`task/details/${taskData}`);
                    if (response.success && response.success === true) {
                        setCaseIdscurrent(response.data.case_og_id);
                    }
                } catch (error) {
                    console.error("Error fetching onboarding data:", error);
                } finally {
                    setLoading(false);
                }
            };

            fetchData();
        }
    }, [taskData, navigate]);
    const fetchData = useCallback(async () => {
        if(onboardslug && userid && showCurrcase){
            try {
            const response = await apiService.getRequest(`/onboarding/${onboardslug}/${userid}/${showCurrcase}`);
            if (response.success && response.success === true) {
                setShowCase(response.data.can_see_case);
                setCaseAllDetail(response.data.case);
                setJobseekername(response.data.jobseeker.name);
                setJobseekerid(response.data.jobseeker.id);
                setcaseid(response?.data);
                
            }else{
                if(response.error_code === "E_PERMISSION_DENIED"){
                    toast.error(response.message || "Permission denied!");
                    navigate("/dashboard");
                }else if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
            } catch (error) {
            console.error("Error fetching onboarding data:", error);
            } finally {
                setLoading(false);
            }
        }
    }, [onboardslug, userid, showCurrcase, navigate]);
        
    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const [errorsCase, setErrorsCase] = useState({});
    const [errorsCaseMessage, setErrorMessageCase] = useState("");
    const [selectedCaseStatus, setSelectedCaseStatus] = useState("");
    const [showCasepop, setShowCasepop] = useState(false);
    const [loadingCase, setSubmitloaderCase] = useState(false);
    const [caseActionform, setCaseActionForm] = useState({
        status: "",
        justification: "",
    })

    const handleselectCase = (statussend) => {
        setSelectedCaseStatus(statussend);
        setShowCasepop(true);
        setCaseActionForm((prevData) => ({
            ...prevData,
            status: statussend,
        }));
    };
    const handleCloseCase = () => setShowCasepop(false);

    const handleInputCasedata = (e) => {
        const { name, value } = e.target;

        const newValue = name === "to_onboarding_id" ? Number(value) : value;

        setCaseActionForm((prevData) => ({
            ...prevData,
            [name]: newValue,
        }));

        setErrorsCase((prevErrors) => ({
            ...prevErrors,
            [name]: '',
        }));
    };

    const validateFormCase = () => {
        const newErrors = {};
        if (!caseActionform.justification) newErrors.justification = "Justification is required.";
        if (caseActionform.justification && caseActionform.justification.length < 3) {
            newErrors.justification = "justification must be at least 3 characters long.";
        }else if (caseActionform.justification && caseActionform.justification.length > 4000) {
            newErrors.justification = 'justification must be less than 4000 characters long.';
        }
        setErrorsCase(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleCaseStatus = async (e) => {
        e.preventDefault();
        if (!validateFormCase()) {
            setErrorMessageCase('Please fix the errors before proceeding.');
            return;
        }
        setSubmitloaderCase(true);
        try {
            const response = await apiService.postRequest(`/task-cases/${CaseAlldetail.id}/status`, caseActionform);
            
            if (response && response.success === true) {
                fetchData();
                window.location.reload();
                setErrorMessageCase("");
                setShowCasepop(false);
                setCaseActionForm({
                    status: "",
                    justification: "",
                })
            } else {
                if (response.errors) {
                    setErrorsCase(response.errors);
                }
                toast(response.message || "Somthing went wrong!")
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.log(error,'Failed. Please try again.');
        } finally {
            setActiveTab("overview");
            setActiveTabCase("task");
            setSubmitloaderCase(false); // Stop loader
        }
    };
    // const [errors, setErrors] = useState({});
    const [errorMessage, setErrorMessage] = useState('');
    // Handle form submission
    const [jobseekDocum, SetJobseekDocu] = useState([]);
    const [jobseekEnvelop, SetJobseekenvelop] = useState([]);
    // New Docu sign
    useEffect(() => {
        const fetchDetailsUser = async () => {
            const params = ({
                task_id: taskData,
                callback_uri:`${window.location.origin}/task/placement-agreements/${userid}`
            });
            try {
            const response = await apiService.postRequest(`/docusign/task-envelopes`,params);
            if (response.success && response.success === true) {
                SetJobseekDocu(response.data);
                SetJobseekenvelop(response.data.envelopes);
                setErrorMessage("");
            }else{
                setErrorMessage(response.message);
            }
            } catch (error) {
                console.error("Error fetching onboarding data:", error);
            }finally {
                setTimeout(() => {
                    setInLoading(false);
                }, 3000);
            }
        };
    
        fetchDetailsUser();
    }, [userid,taskData]);
    const rows = jobseekEnvelop && jobseekEnvelop.map((datas,index) => ({
        index:index+1,
        id:datas.formatted_id,
        document: datas.documents,
        document_link: datas.document_link,
        document_download_link: datas.document_download_link,
        status: datas.status,
        assigned_to: datas.assignment_to,
        author: datas.author,
        last_updated: datas.lastUpdatedDate,
    }));
    const rows2 = jobseekDocum?.envelopes?.[showIndex]?.signers?.map((signer, index) => ({
        id: index+1,
        order: signer.route_order,
        recipient: signer.name,
        email: signer.email,
        role: signer.role,
        status: signer.status,
        last_updated: signer.date, // Convert boolean to readable text
    })) || [];
    
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const paginatedRows = rows && rows.slice(currentPage * pageSize, currentPage * pageSize + pageSize);
    
    const columns2 = [
        {
            field: 'order',
            headerName: 'Order',
            width: 150,
            filterable: false,
            sortable: false,
        },
        {
            field: 'recipient',
            headerName: 'Recipient',
            width: 300,
            renderCell: (params) => (
                <div className='d-flex flex-column justify-content-center h-100'>
                    <span>{params.row.name}</span>
                    <span>{params.row.email}</span>
                </div>
            ),
            filterable: false, sortable: false,
        },
        {
            field: 'role',
            headerName: 'Role',
            width: 250,
            filterable: false, sortable: false,
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 200,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    {params.row.status === "created" ?
                        <span style={{color:"#6c757d"}}>Created</span>
                        :params.row.status === "sent" ?
                        <span style={{color:"#007bff"}}>Sent</span>
                        :params.row.status === "delivered" ?
                        <span style={{color:"#ffc107"}}>Delivered</span>
                        :params.row.status === "completed" ?
                        <span style={{color:"#28a745"}}>Completed</span>
                        :params.row.status === "declined" ?
                        <span style={{color:"#dc3545"}}>Declined</span>
                        :params.row.status === "voided" ?
                        <span style={{color:"#343a40"}}>Voided</span>
                        :params.row.status === "signed" ?
                        <span style={{color:"#17a2b8"}}>Signed</span>
                        :params.row.status === "correct" ?
                        <span style={{color:"#6f42c1"}}>Correct</span>
                        :params.row.status === "expired" ?
                        <span style={{color:"#dc3545"}}>Expired</span>
                        :params.row.status === "fax_pending" ?
                        <span style={{color:"#ffc107"}}>Fax Pending</span>
                        :params.row.status === "authentication_failed" ?
                        <span style={{color:"#dc3545"}}>Authentication Failed</span>
                        :<span style={{color:"#000",textTransform:"capitalize"}}>{params.row.status}</span>
                    }
                </div>
            ),
            filterable: false, sortable: false,
        },
        {
            field: 'last_updated',
            headerName: 'Last Updated',
            width: 250,
            filterable: false, sortable: false,
        },
    ]
    const columns = [
        {
            field: 'id',
            headerName: 'ID',
            width: 80,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span className='link_datatspan' onClick={() =>{setShow(true);setShowindex(params.row.index - 1)}}>
                        {params.row.id}
                    </span>
                </div>
            ),
            filterable: false,
            sortable: false,
        },
        {
            field: 'document',
            headerName: 'Document',
            width: 300,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    {params.row.document.map((datadoc,index)=>(
                    <span key={index}>
                        {datadoc.name}
                    </span>
                    ))}
                </div>
            ),
            filterable: false, sortable: false,
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 200,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    {params.row.status === "created" ?
                        <span style={{color:"#6c757d"}}>Created</span>
                        :params.row.status === "sent" ?
                        <span style={{color:"#007bff"}}>Sent</span>
                        :params.row.status === "delivered" ?
                        <span style={{color:"#ffc107"}}>Delivered</span>
                        :params.row.status === "completed" ?
                        <span style={{color:"#28a745"}}>Completed</span>
                        :params.row.status === "declined" ?
                        <span style={{color:"#dc3545"}}>Declined</span>
                        :params.row.status === "voided" ?
                        <span style={{color:"#343a40"}}>Voided</span>
                        :params.row.status === "signed" ?
                        <span style={{color:"#17a2b8"}}>Signed</span>
                        :params.row.status === "correct" ?
                        <span style={{color:"#6f42c1"}}>Correct</span>
                        :params.row.status === "expired" ?
                        <span style={{color:"#dc3545"}}>Expired</span>
                        :params.row.status === "fax_pending" ?
                        <span style={{color:"#ffc107"}}>Fax Pending</span>
                        :params.row.status === "authentication_failed" ?
                        <span style={{color:"#dc3545"}}>Authentication Failed</span>
                        :<span style={{color:"#000",textTransform:"capitalize"}}>{params.row.status}</span>
                    }
                </div>
            ),
            filterable: false, sortable: false,
        },
        {
            field: 'assigned_to',
            headerName: 'Assigned To',
            width: 250,
            filterable: false, sortable: false,
        },
        {
            field: 'author',
            headerName: 'Author',
            width: 250,
            filterable: false, sortable: false,
        },
        {
            field: 'last_updated',
            headerName: 'Last Updated',
            width: 250,
            filterable: false, sortable: false,
        },
        {
            field: 'action',
            headerName: 'Action',
            width: 200,
            filterable: false,
            sortable: false,
            renderCell: (params) => (
                <Grid size={{ xs: 12 }} container alignItems="center" justifyContent="flex-start" className="gap-md-3 h-100 gap-2">
                    <a href={`${params.row.document_link}`} target="_blank" rel="noopener noreferrer" className='editbtnroot'>
                        <FontAwesomeIcon icon={faEye} />
                    </a>
                    <a href={`${params.row.document_download_link}`} target="_blank" rel="noopener noreferrer" className='trashbtnroot'>
                        <FontAwesomeIcon icon={faDownload} />
                    </a>
                </Grid>
            ),
        },
    ];
  return (
    <div className='container-fluid px-0'>
        <div className='content_container_validate' style={{ flexGrow: 1 }}>
            <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead mb-3">
            <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> 
                    <FontAwesomeIcon className='angleright' icon={faAngleRight} /> 
                    <b className="formatid_copyclip my-0 fw-bold text-decoration-none" style={{color:"#1A5298", width:"max-content"}}
                        onClick={async () => {
                            const url = `${window.location.origin}${caseids?.case?.case_link}`;
                            const title = "Onboarding " + caseids?.jobseeker?.name + " - " + caseids?.jobseeker?.formatted_id;
                            const textPlain = `${caseids?.case?.case_formatted_id}: ${title}\n${url}`;
                            const textHtml = `<a href="${url}" target="_blank">${caseids?.case?.case_formatted_id}: ${title}</a>`;
                            try {
                            await navigator.clipboard.write([
                                new ClipboardItem({
                                "text/html": new Blob([textHtml], { type: "text/html" }),
                                "text/plain": new Blob([textPlain], { type: "text/plain" }),
                                }),
                            ]);
                            toast("Link copied to clipboard");
                            } catch (err) {
                            console.error("Failed to copy: ", err);
                            toast("Failed to copy link");
                            }
                        }}
                        >
                        {caseids?.case?.case_formatted_id}
                    </b>
                    <FontAwesomeIcon className='angleright' icon={faAngleRight} />
                    <b className="formatid_copyclip my-0 fw-bold text-decoration-none" style={{color:"#1A5298", width:"max-content"}}
                        onClick={async () => {
                            const url = `${window.location}`;
                            const title = "Onboarding " + caseids?.jobseeker?.name + " - " + caseids?.jobseeker?.formatted_id;
                            const textPlain = `${caseids?.task?.task_format_id} - ${caseids?.case?.case_formatted_id}: ${title}\n${url}`;
                            const textHtml = `<a href="${url}" target="_blank">${caseids?.case?.case_formatted_id}: ${title}</a>`;
                            try {
                            await navigator.clipboard.write([
                                new ClipboardItem({
                                "text/html": new Blob([textHtml], { type: "text/html" }),
                                "text/plain": new Blob([textPlain], { type: "text/plain" }),
                                }),
                            ]);
                            toast("Link copied to clipboard");
                            } catch (err) {
                            console.error("Failed to copy: ", err);
                            toast("Failed to copy link");
                            }
                        }}
                        >
                        {caseids?.task?.task_format_id}
                    </b>
                </span>
            </Grid>  
            {loading ? 
                <div className='d-flex justify-content-center w-100'>
                    <img style={{ width: "100px" }} src={require('../../../../assets/pinkloader.gif')} alt='Loading...' />
                </div> :
                <Grid size={{sm:12}} container className="main_jobseeker justify-content-between">
                    <Grid size={{ lg: !showCase ? 12 : expanded ? 7.6 : 11.5, md: !showCase ? 12 : expanded ? 7 : 11, xs: 12 }} sx={{ transition: "all 0.35s cubic-bezier(0.4,0,0.2,1)" }} container className={`tab_controllers ${ Role_user && Role_user !== "job_seeker" ? "flex-row-reverse pe-4 align-items-start align-content-start justify-content-between" : "hide_tabseeker"}`} >
                        {Role_user && Role_user !== "job_seeker" ?
                        <Grid container className="gap-3 case_control_btn" justifyContent="flex-end">
                            {showCase && activeTabCase === "case" && <>
                            {CaseAlldetail?.status !== "suspend" && CaseAlldetail?.status !== "completed" && CaseAlldetail?.status !== "rejected" && <>
                                {CaseAlldetail?.status !== "hold" ?
                                    <button className='registersendbtn1 my-0' onClick={()=> handleselectCase("hold")}>Hold</button>:
                                    <button className='registersendbtn1 my-0' onClick={()=> handleselectCase("resume")}>Resume</button>
                                }
                            </>}
                            {CaseAlldetail?.status !== "hold" && CaseAlldetail?.status !== "completed" && CaseAlldetail?.status !== "rejected" && <>
                                {CaseAlldetail?.status !== "suspend" ?
                                <button className='registersendbtn1 my-0' onClick={()=> handleselectCase("suspend")}>Suspend</button>:
                                ""
                                }
                            </>}
                            </>}
                        </Grid>:<div></div>}
                        <Tabs
                            activeKey={activeTabCase}
                            onSelect={(key) => setActiveTabCase(key)}
                            defaultActiveKey="task"
                            id="uncontrolled-tab-example" className="mb-4 drafttabs_tabs tabs_noneseeker"
                        >
                            <Tab eventKey="task" title="Task">
                                <Grid size={{sm:12}} container alignItems="center">
                                    <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead border_botomer mario_fixers">
                                        <h3>Placement Agreement</h3>
                                        {Role_user && Role_user !== "job_seeker" ? <>
                                            {permissionstest && (permissionstest.manage_jobseeker_reader || permissionstest.manage_jobseeker_writer) ? 
                                                <Link className='seekerondetail' to={`/user/jobseeker-details/${jobseekerid}`} target='_blank' >{caseids?.jobseeker?.formatted_id} - {jobseekerName}</Link>:
                                                <Link className='seekerondetail' to={`/user/jobseeker-profile/${jobseekerid}`} target='_blank' >{caseids?.jobseeker?.formatted_id} - {jobseekerName}</Link>
                                            }
                                        </>:<b>{jobseekerName}</b>}
                                    </Grid>
                                    <Grid size={{xs:12}} container flexDirection="column" justifyContent="center" className={`tab_controllers ${ expanded && "control_splits"}`}>
                                        <Tabs
                                            activeKey={activeTab}
                                            onSelect={(key) => setActiveTab(key)} 
                                            defaultActiveKey="overview"
                                            id="uncontrolled-tab-example" className="mt-4 drafttabs_tabs"
                                            >
                                            <Tab eventKey="overview" title="Overview" className={`${ expanded && "expanded-grid"}`}>
                                            {inLoading ? 
                                            <div className='d-flex justify-content-center w-100'>
                                                <img style={{ width: "100px" }} src={require('../../../../assets/pinkloader.gif')} alt='Loading...' />
                                            </div> :<>
                                            {jobseekDocum && jobseekDocum.must_wait && jobseekDocum.must_wait === true ? 
                                            <Grid size={{xs:12}} container>
                                                <Grid size={{xs:12}} container justifyContent="space-between" alignItems="center" className="my-4 p-3 placementPriviewblue">
                                                    <span>{jobseekDocum.must_wait_message}</span>
                                                </Grid>
                                            </Grid>
                                            :<>
                                                {Role_user && Role_user === "job_seeker" ? <>
                                                {errorMessage && errorMessage.length > 0 ? 
                                                <Grid size={{xs:12}} container>
                                                    <Grid size={{xs:12}} container justifyContent="space-between" alignItems="center" className="my-4 p-3 placementPriviewblue">
                                                        <span>{errorMessage}</span>
                                                    </Grid>
                                                </Grid>
                                                :<>
                                                {jobseekDocum && jobseekDocum.can_sign === true ?
                                                <Grid size={{xs:12}} container>
                                                    <Grid size={{xs:12}} container justifyContent="space-between" alignItems="center" className="my-4 p-3 placementPriviewblue">
                                                        <span>{jobseekDocum.can_signed_msg}</span>
                                                    </Grid>
                                                    {jobseekDocum && jobseekDocum.envelopes && jobseekDocum.envelopes.map((envelopeslist, index) => (
                                                        <Grid size={{ xs: 12 }} container key={index}>
                                                            {envelopeslist && envelopeslist.documents.map((documentslist, indexs) => (
                                                                <Grid size={{ xs: 12 }} container key={indexs}>
                                                                    <a href={`${documentslist.document_link}`} target="_blank" rel="noopener noreferrer" className='signingdocument d-flex align-items-center'>
                                                                        <FontAwesomeIcon className='icondocuplacement' icon={faFilePdf} />
                                                                        <span>{documentslist.name}</span>
                                                                    </a>
                                                                </Grid>
                                                            ))}
                                                        </Grid>
                                                    ))}
                                                </Grid>
                                                :
                                                    <Grid size={{xs:12}} container>
                                                        {jobseekDocum && jobseekDocum.envelopes && jobseekDocum.envelopes.map((envelopeslist, index) => (
                                                            <Grid size={{ xs: 12 }} container key={index}>
                                                                {envelopeslist && envelopeslist.documents.map((documentslist, indexs) => (
                                                                    <Grid size={{xs:12}} key={indexs} container justifyContent="space-between" alignItems="center" className="my-4 p-3 placementPriviewblue">
                                                                        <span>{jobseekDocum.all_signed_msg} {documentslist.name}</span>
                                                                        <a href={jobseekDocum && jobseekDocum.all_signed ? `${documentslist.document_download_link}` : `${documentslist.document_link}`} target="_blank" className='my-md-0 mt-3' rel="noopener noreferrer">{jobseekDocum && jobseekDocum.all_signed === true ? "Download Document" : "View Document"}</a>
                                                                    </Grid>
                                                                ))}
                                                            </Grid>
                                                        ))}
                                                        <Grid size={{xs:12}} container className="overflow-auto">
                                                            <Grid size={{xs:12}} container alignContent="flex-start" className="mt-3 tabmin_shorthis">
                                                                <Grid size={{xs:12}} container className="history_tableheads">
                                                                    <Grid size={{xs:1.5}} container>
                                                                        <h6>Order</h6>
                                                                    </Grid>
                                                                    <Grid size={{xs:5}} container>
                                                                        <h6>Recipient</h6>
                                                                    </Grid>
                                                                    <Grid size={{xs:3}} container>
                                                                        <h6>Role</h6>
                                                                    </Grid>
                                                                    <Grid size={{xs:2.5}} container>
                                                                        <h6>Status</h6>
                                                                    </Grid>
                                                                </Grid>
                                                                {jobseekDocum && jobseekDocum.envelopes && jobseekDocum.envelopes.map((envelopeslist, index) => (
                                                                    <Grid size={{ xs: 12 }} container key={index}>
                                                                        {envelopeslist && envelopeslist.documents.map((documentslist, indexs) => (
                                                                            <Grid size={{xs:12}} key={indexs} container>
                                                                                {documentslist && documentslist.signers.map((signerslist, indexsigners) => (
                                                                                    <Grid size={{xs:12}} alignItems="center" key={indexsigners} container className="history_tableans placement_table">
                                                                                        <Grid size={{xs:1.5}} container>
                                                                                            <span><b>{signerslist.route_order}</b></span>
                                                                                        </Grid>
                                                                                        <Grid size={{xs:5}} container flexDirection="column">
                                                                                            <span>{signerslist.name}</span>
                                                                                            <span>{signerslist.email}</span>
                                                                                        </Grid>
                                                                                        <Grid size={{xs:3}} container flexDirection="column">
                                                                                            <span>{signerslist.role}</span>
                                                                                        </Grid>
                                                                                        <Grid size={{xs:2.5}} container flexDirection="column">
                                                                                            {signerslist && signerslist.status === "created" ?
                                                                                                <span style={{color:"#6c757d"}}>Created</span>
                                                                                                :signerslist && signerslist.status === "sent" ?
                                                                                                <span style={{color:"#007bff"}}>Sent</span>
                                                                                                :signerslist && signerslist.status === "delivered" ?
                                                                                                <span style={{color:"#ffc107"}}>Delivered</span>
                                                                                                :signerslist && signerslist.status === "completed" ?
                                                                                                <span style={{color:"#28a745"}}>Completed</span>
                                                                                                :signerslist && signerslist.status === "declined" ?
                                                                                                <span style={{color:"#dc3545"}}>Declined</span>
                                                                                                :signerslist && signerslist.status === "voided" ?
                                                                                                <span style={{color:"#343a40"}}>Voided</span>
                                                                                                :signerslist && signerslist.status === "signed" ?
                                                                                                <span style={{color:"#17a2b8"}}>Signed</span>
                                                                                                :signerslist && signerslist.status === "correct" ?
                                                                                                <span style={{color:"#6f42c1"}}>Correct</span>
                                                                                                :signerslist && signerslist.status === "expired" ?
                                                                                                <span style={{color:"#dc3545"}}>Expired</span>
                                                                                                :signerslist && signerslist.status === "fax_pending" ?
                                                                                                <span style={{color:"#ffc107"}}>Fax Pending</span>
                                                                                                :signerslist && signerslist.status === "authentication_failed" ?
                                                                                                <span style={{color:"#dc3545"}}>Authentication Failed</span>
                                                                                                :<span style={{color:"#000",textTransform:"capitalize"}}>{signerslist.status}</span>
                                                                                            }
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                ))}
                                                                            </Grid>
                                                                        ))}
                                                                    </Grid>
                                                                ))}
                                                            </Grid>
                                                        </Grid>
                                                        
                                                    </Grid>
                                                }
                                                </>}
                                                </> :<>
                                                {errorMessage && errorMessage.length > 0 ? 
                                                <Grid size={{xs:12}} container>
                                                    <Grid size={{xs:12}} container justifyContent="space-between" alignItems="center" className="my-4 p-3 placementPriviewblue">
                                                        <span>{errorMessage}</span>
                                                    </Grid>
                                                </Grid>
                                                :<>
                                                <div className='overflowwer_fullwidth w-100 mt-4'>
                                                    {loading ? 
                                                        <div className='d-flex justify-content-center w-100'>
                                                            <img style={{ width: "100px" }} src={require('../../../../assets/pinkloader.gif')} alt='Loading...' />
                                                        </div> :<>
                                                        {jobseekDocum && jobseekDocum.envelopes && jobseekDocum.envelopes.length > 0 ? (
                                                            <Box sx={{ height: 650, width: '100%' }} className="datatable_jobpagi">
                                                                <DataGrid
                                                                    rows={paginatedRows}
                                                                    columns={columns}
                                                                    pageSize={pageSize}
                                                                    disableSelectionOnClick
                                                                    components={{ Toolbar: GridToolbar }}
                                                                />
                                                            </Box>
                                                        ) : (
                                                            <div className="w-100 d-flex justify-content-center mt-4">
                                                                <p>No data to display</p>
                                                            </div>
                                                        )}
                                                    </>}
                                                </div>
                                                <Grid size={{xs:12}} container className="datatable_jobpagi_indi">
                                                    <div className='d-flex flex-column w-100 my-3 pagination_datagrid'>
                                                        <div className='d-flex justify-content-end align-items-center'>
                                                            <label>No. of Rows</label>
                                                            <select
                                                                label="Rows per page"
                                                                value={pageSize}
                                                                onChange={(e) => {setPageSize(Number(e.target.value)); setCurrentPage(0);}}
                                                                sx={{ mr: 2 }}
                                                            >
                                                                {[5, 10, 20, 50].map((size) => (
                                                                    <option key={size} value={size}>{size}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                        
                                                        <div className="d-flex justify-content-center my-3">
                                                            <button
                                                                className='nexter_btns'
                                                                variant="contained"
                                                                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 0))}
                                                                disabled={currentPage === 0}
                                                            >
                                                                <FontAwesomeIcon icon={faChevronLeft} />
                                                            </button>
                                                            <div className="d-flex align-items-center mx-2">
                                                                {Array.from({ length: Math.ceil(rows && rows.length / pageSize) }, (_, index) => (
                                                                    <button
                                                                        key={index}
                                                                        className={`page-btn ${currentPage === index ? 'active' : ''}`}
                                                                        onClick={() => setCurrentPage(index)}
                                                                    >
                                                                        {index + 1}
                                                                    </button>
                                                                ))}
                                                            </div>
                                                            <button
                                                                className='nexter_btns'
                                                                variant="contained"
                                                                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, Math.ceil(rows && rows.length / pageSize) - 1))}
                                                                disabled={currentPage >= Math.ceil(rows && rows.length / pageSize) - 1}
                                                            >
                                                                <FontAwesomeIcon icon={faChevronRight} />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </Grid>
                                                </>}
                                                </>}
                                            </>}
                                                </>}
                                            </Tab>
                                            <Tab eventKey="knowledge" title="Knowledge">
                                                {activeTab === "knowledge" && <TaskKnowledge />}
                                            </Tab>
                                        </Tabs>
                                    </Grid>
                                </Grid>
                            </Tab>
                            {showCase &&
                            <Tab eventKey="case" title="Case">
                                {activeTabCase === "case" && <CaseDetails expanded={expanded}/>}
                            </Tab>}
                        </Tabs>
                    </Grid>
                    {showCase &&
                    <Grid alignContent="flex-start" size={{ lg: expanded ? 4.4 : 0.5, md: expanded ? 5 : 0.4, xs: 12, }} container className="border-start ps-3" sx={{ transition: "all 0.35s cubic-bezier(0.4,0,0.2,1)", overflow: "hidden", minWidth: expanded ? undefined : 0, }}>
                        <button onClick={() => setExpanded((prev) => !prev)} className='main_expanddisbtn'>
                            {expanded ? <FontAwesomeIcon icon={faChevronRight} /> : <FontAwesomeIcon icon={faChevronLeft} />}
                        </button>
                        <Grid size={{xs:12}} container className={ expanded ? "" : "d-none"}>
                            <OnboardingOnlyCaseDiscussTab showCase={showCase} caseStatus={caseids?.case?.status}/>
                        </Grid>
                    </Grid>}
                </Grid>}
            <Modal
                show={show} 
                onHide={handleClose}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton style={{border:"none"}}></Modal.Header>
                <Modal.Body>
                <Tabs
                defaultActiveKey="recipients"
                id="uncontrolled-tab-modal" className="drafttabs_tabs"
                >
                    {/* <Tab eventKey="document" title="Document">
                    </Tab> */}
                    <Tab eventKey="recipients" title="Recipients">
                        <Box sx={{ height: 650, width: '100%' }} className="datatable_jobpagi mt-3">
                            <DataGrid
                                style={{minHeight: "200px"}}
                                rows={rows2}
                                columns={columns2}
                                disableSelectionOnClick
                                components={{ Toolbar: GridToolbar }}
                            />
                        </Box>
                    </Tab>
                </Tabs>
                </Modal.Body>
            </Modal>
            <Modal
                show={showCasepop} 
                onHide={handleCloseCase}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton style={{border:"none"}}>
                    
                </Modal.Header>
                <Modal.Body>
                <div className="d-flex w-100 text-center flex-column align-items-center modal_register modal_statuscomplete">
                <FontAwesomeIcon className='statusicons' icon={faCircleExclamation} />
                    {selectedCaseStatus === "suspend" && <small className='fw-bold'>Suspending this case will also suspend the job seeker and block future login.</small>}
                    <p>Are you sure you want to change the status to{" "}<strong className='uppercasers'>{selectedCaseStatus}</strong>?</p>
                    <div className='d-flex w-100 flex-column align-items-start rollback_textarea'>
                        <span>Justification<small className='justify_astrickt'>*</small></span>
                        <textarea className='w-100' maxLength={4001} minLength={3} name='justification' value={caseActionform.justification} onChange={handleInputCasedata}/>
                        {errorsCase.justification && <p style={{color:"Red"}}>{errorsCase.justification}</p>}
                    </div>
                    {errorsCaseMessage && <p style={{color:"Red",width:"100%",textAlign:"left"}}>{errorsCaseMessage}</p>}
                </div>
                </Modal.Body>
                <Modal.Footer>
                <button className='registersendbtn1 my-2 mx-4' onClick={handleCloseCase}>
                    Cancel
                </button>
                <button className='registersendbtn2 my-2' onClick={handleCaseStatus}>
                    {loadingCase ? <img src={require('../../../../assets/whiteloader.gif')} alt=''/> : 'Confirm'}
                </button>
                </Modal.Footer>
            </Modal>
        </div>
    </div>
  )
} 

export default PlacementAgreements
